import { isAfter } from 'date-fns/isAfter';
import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type CreateUploadPayload = z.output<typeof createUploadPayloadSchema>;
export type CreateUploadPayloadDTO = z.input<typeof createUploadPayloadSchema>;

export const createUploadPayloadSchema = z
  .object({
    files: z.array(
      z.object({
        filename: z.string(),
        filesize: z.number().int().positive(),
      }),
    ),
    sessionEnd: isoDatetimeToDate,
    sessionStart: isoDatetimeToDate,
  })
  .refine(({ sessionEnd, sessionStart }) => isAfter(sessionEnd, sessionStart), {
    error: 'sessionEnd must be after sessionStart',
    path: ['sessionEnd'],
  });
